import { render, staticRenderFns } from "./EmployeeAddress2Field.vue?vue&type=template&id=98918722&"
import script from "./EmployeeAddress2Field.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddress2Field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports